import React from 'react';

const TemplateIcon = ({
  width = '16',
  height = '16',
  fill = '#007AFF',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_631_16369)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3.1C1 2.54305 1.22125 2.0089 1.61508 1.61508C2.0089 1.22125 2.54305 1 3.1 1L12.9 1C13.457 1 13.9911 1.22125 14.3849 1.61508C14.7788 2.0089 15 2.54305 15 3.1V4.325H1V3.1ZM1 6.075V12.9C1 13.457 1.22125 13.9911 1.61508 14.3849C2.0089 14.7788 2.54305 15 3.1 15H5.025V6.075H1ZM6.775 15H12.9C13.457 15 13.9911 14.7788 14.3849 14.3849C14.7788 13.9911 15 13.457 15 12.9V6.075H6.775V15Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_631_16369">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default TemplateIcon;
